import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatMenuTrigger } from '@angular/material/menu';
import { DynamicDropdownService } from '@app/services/dynamic-dropdown.service';
import { TourGuideService } from '@app/services/tour-guide.service';
import { Messages } from '@app/src/util/messages.util';
import { Subscription } from 'rxjs';
import dummyData from '@app/assets/api-dummy-data.json';

@Component({
  selector: 'app-dynamic-dropdown',
  templateUrl: './dynamic-dropdown.component.html',
  styleUrls: ['./dynamic-dropdown.component.scss']
})
export class DynamicDropdownComponent implements OnInit {

  /****************** Variable declaration ******************/
  dataSubscription: Subscription

  /****************** View child ******************/
  @ViewChild('mainMenuTrigger') mainMenuTrigger!: MatMenuTrigger;

  /****************** Input and Output decorators ******************/
  @Input() data: any;
  @Input() targetMenu = "menu";
  @Input() isRootNode = false;
  @Input() isSelect = false;
  @Input() childFormControl: FormControl;
  @Input() isWorkflowConfig: boolean;
  @Input() isGithubActions: boolean;
  @Input() title: any;
  @Input() placeholder: any;
  @Input() feature: any = '';
  @Output() selectedValueChange = new EventEmitter<string>();
  @Output() itemSelected = new EventEmitter<any>();

  /**
   * Constructor
   * @param dpService 
   */
  constructor(public dpService: DynamicDropdownService,
    public guideService: TourGuideService) {
    this.dataSubscription = this.guideService.data$.subscribe((res: any) => {
      if (this.guideService.isStartTour) {
        if (res.page == 'gitAction') {
          this.data = dummyData.githubAction.wfDataDropdown;
        }

        if (res.operation === true || res == true) {
          this.mainMenuTrigger.openMenu();
        } else if (res.operation === false || res == false || res.operation == 'skip' || res.operation == 'close') {
          this.mainMenuTrigger.closeMenu();
        }
      }
    })
  }

  /**ngOnInit */
  ngOnInit(): void {

  }

  ngOnDestroy() {
    if (this.dataSubscription) {
      this.dataSubscription.unsubscribe();
    }
  }

  /** open menu function is used whenever dropdown is clicked */
  openMenu() {
    // Reset search terms in every recursive-menu instance every time the
    // dropdown is reopened.
    this.dpService.resetSearches();

    if (this.isWorkflowConfig) {
      const data = { isWorkflowCngDrpdn: true };
      this.dpService.sendBoolData(data);
    } else if (this.isGithubActions) {
      const data = { isGithubDrpdn: true };
      this.dpService.sendBoolData(data);
    }

    if (this.childFormControl.disabled) return;

    let box = document.getElementsByClassName('cdk-overlay-container');
    const boxElements = Array.from(box) as HTMLElement[];

    boxElements.forEach(ele => {
      ele.classList.remove('displayBlock')
    });
  }

  /**get workflow error */
  getWfErr() {
    return Messages.addConfigNew.wfValidation
  }
}
